<template>
  <main>
    <div class="organism-policy_container">
      <div class="organism-policy_header">
        <label class="header__label">Enable Event Monitoring</label>
        <!-- In Case that manage policy for each equipment-->
        <div v-if="!isFromTripleDot" @change="onClickSwitchEnable">
          <atom-switch 
            v-model="currentSwitchValue" 
            :isDisable="!hasUpdatePermission"
          ></atom-switch>
        </div>

        <!-- In Case that action from triple dot -->
        <div v-else @click="onClickSwitchEnableForActionFromTripleDot">
          <atom-switch
            v-model="switchValueForActionFromTripleDot"
          ></atom-switch>
        </div>
      </div>

      <!-- In Case that manage policy for each equipment-->
      <section v-if="!isFromTripleDot">
        <section v-if="currentEquipmentPolicyData.isEnable">
          <div class="organism-policy_line"></div>
          <div class="organism-policy_body">
            <div>
              <label class="policy__label">Select Policy</label>
              <atom-select
                class="policy__select"
                label="policyName"
                v-model="currentEquipmentPolicyData.currentPolicy"
                :option="policyListAll"
                :isClearable="false"
                :isAppendToBody="false"
                :isEnableProper="false"
                :isDisable="!hasUpdatePermission"
                @input="changeSelectedPolicy"
              ></atom-select>
            </div>

            <!-- create new policy -->
            <div v-if="currentEquipmentPolicyData.currentPolicy">
              <div
                v-if="
                  currentEquipmentPolicyData.currentPolicy.policyName ===
                  'Create Policy'
                "
                class="policy__create"
              >
                <div class="create__title">New Policy</div>

                <div class="create__container">
                  <atom-input
                    class="create__name"
                    title="Policy Name"
                    placeholder="Policy Name"
                    v-model="newPolicy.name"
                    :isAsterisk="true"
                    :isError="isErrorCreatePolicyName"
                    :errorMessage="errorCreatePolicyName"
                  ></atom-input>
                  <atom-input
                    class="create__description"
                    title="Description"
                    placeholder="Description"
                    v-model="newPolicy.description"
                    :isAsterisk="true"
                    :isError="isErrorCreatePolicyDescription"
                    :errorMessage="errorCreatePolicyDescription"
                  ></atom-input>
                </div>
              </div>
              <molecule-list-resource
                :policy="
                  (currentEquipmentPolicyData.currentPolicy.policyName ===
                    'Custom Policy' ||
                  currentEquipmentPolicyData.currentPolicy.policyName ===
                    'Create Policy') && hasUpdatePermission
                    ? 'edit'
                    : 'view'
                "
                :columns="columns"
                :unitList="unitList"
                :isEditPath="true"
                :isClickApply="isClickApply"
                v-model="currentRows"
                @errorInput="errorInResource"
              ></molecule-list-resource>
              <div
                v-if="isClickApply && !completeAtLeastOneRow"
                class="error__text d-flex align-items-center"
              >
                <feather-icon icon="AlertCircleIcon"></feather-icon>
                <span class="padding-left-5px"
                  >Please select at least 1 system resource</span
                >
              </div>
            </div>

            <div v-if="hasUpdatePermission" class="policy__button d-flex justify-content-end">
              <atom-button
                buttonId="button-apply"
                class="button__apply"
                @click="clickApply"
                :isDisable="isDisableApplyButton"
              >
                <template>
                  <div class="apply__normal">
                    {{ messageInButtonApplyNormalVersion }}
                  </div>
                  <div class="apply__short">
                    {{ messageInButtonApplyShortVersion }}
                  </div>
                </template>
              </atom-button>

              <atom-button
                v-if="isEdit"
                buttonId="button-discard"
                buttonStyle="border"
                buttonColor="secondary"
                @click="clickDiscard"
                class="button__discard"
              >
                <template>Cancel</template>
              </atom-button>
            </div>
          </div>
        </section>
      </section>

      <!-- In Case that action from triple dot -->
      <section v-else>
        <section v-if="switchValueForActionFromTripleDot">
          <div class="organism-policy_line"></div>
          <div class="organism-policy_body">
            <div>
              <label class="policy__label">Select Policy</label>
              <atom-select
                class="policy__select"
                label="policyName"
                v-model="currentPolicyDataForActionFromTripleDot"
                :option="policyListAll"
                :isClearable="false"
                :isAppendToBody="false"
                :isEnableProper="false"
                @input="changeSelectedPolicy"
              ></atom-select>
            </div>

            <!-- create new policy -->
            <div v-if="currentPolicyDataForActionFromTripleDot">
              <div
                v-if="
                  currentPolicyDataForActionFromTripleDot.policyName ===
                  'Create Policy'
                "
                class="policy__create"
              >
                <div class="create__title">New Policy</div>

                <div class="create__container">
                  <atom-input
                    class="create__name"
                    title="Name Policy"
                    placeholder="Name Policy"
                    v-model="newPolicy.name"
                    :isAsterisk="true"
                    :isError="isErrorCreatePolicyName"
                    :errorMessage="errorCreatePolicyName"
                  ></atom-input>
                  <atom-input
                    class="create__description"
                    title="Description"
                    placeholder="Description"
                    v-model="newPolicy.description"
                    :isAsterisk="true"
                    :isError="isErrorCreatePolicyDescription"
                    :errorMessage="errorCreatePolicyDescription"
                  ></atom-input>
                </div>
              </div>
              <molecule-list-resource
                :policy="
                  currentPolicyDataForActionFromTripleDot.policyName ===
                  'Create Policy'
                    ? 'edit'
                    : 'view'
                "
                :columns="columns"
                :unitList="unitList"
                :isEditPath="true"
                :isClickApply="isClickApply"
                v-model="currentRows"
                @errorInput="errorInResource"
              ></molecule-list-resource>
              <div
                v-if="isClickApply && !completeAtLeastOneRow"
                class="error__text d-flex align-items-center"
              >
                <feather-icon icon="AlertCircleIcon"></feather-icon>
                <span class="padding-left-5px"
                  >Please select at least 1 system resource</span
                >
              </div>
            </div>

            <div class="policy__button d-flex justify-content-end">
              <atom-button
                buttonId="button-apply"
                class="button__apply"
                @click="clickApplyForActionFromTripleDot"
                :isDisable="isDisableApplyButtonForActionFromTripleDot"
              >
                <template>
                  <div class="apply__normal">
                    {{ messageInButtonApplyNormalVersion }}
                  </div>
                  <div class="apply__short">
                    {{ messageInButtonApplyShortVersion }}
                  </div>
                </template>
              </atom-button>

              <atom-button
                v-if="isEdit"
                buttonId="button-discard"
                buttonStyle="border"
                buttonColor="secondary"
                @click="clickDiscard"
                class="button__discard"
              >
                <template>Cancel</template>
              </atom-button>
            </div>
          </div>
        </section>
      </section>

      <molecule-modal-dialog
        modalId="modal-confirm-enable-monitor-event"
        :isTextCenter="true"
        :textTitle="`Do you want to ${
          currentEquipmentPolicyData.isEnable ? 'Disable' : 'Enable'
        } Monitoring\nfor ${equipmentData.name}?`"
        buttonTextLeft="Confirm"
        @clickButtonLeft="clickConfirmIsEnabled"
      ></molecule-modal-dialog>

      <molecule-modal-dialog
        v-if="!Array.isArray(equipmentData)"
        modalId="modal-confirm-apply-monitor-event"
        :isTextCenter="true"
        :textTitle="`Do you want to Apply\nfor ${equipmentData.name}?`"
        textSubtitle="This will apply system resources threshold."
        buttonTextLeft="Apply"
        @clickButtonLeft="clickConfirmApply"
      ></molecule-modal-dialog>

      <molecule-modal-dialog
        v-if="Array.isArray(equipmentData)"
        modalId="modal-confirm-apply-monitor-event"
        :isTextCenter="true"
        textTitle="Do you want to apply Policy?"
        buttonTextLeft="Apply"
        :isSlotBody="true"
        @clickButtonLeft="clickConfirmApply"
      >
        <template #body>
          <div class="modal-confirm-enable-monitor-event__list--full">
            <label class="list__title"
              >“<span class="list__title--medium">{{ selectPolicy }}</span
              >” will be applied to</label
            >
            <ul class="list__ul">
              <li
                v-for="(equipment, index) in equipmentData"
                :key="index"
                class="list__li"
              >
                <label class="list__label">{{ equipment.name }}</label>
              </li>
            </ul>
          </div>
        </template>
      </molecule-modal-dialog>

      <molecule-modal-dialog
        modalId="server-management_modal-confirm-create-policy"
        :isTextCenter="true"
        :textTitle="`Do you want to\ncreate “${newPolicy.name}” ?`"
        buttonTextLeft="Confirm"
        @clickButtonLeft="clickConfirmCreate"
      ></molecule-modal-dialog>

      <molecule-modal-dialog
        modalId="server-management_modal-confirm-save-policy"
        :isTextCenter="true"
        :textTitle="`Do you want to save\n“${currentEquipmentPolicyData.currentPolicy.policyName}” ?`"
        buttonTextLeft="Confirm"
        @clickButtonLeft="clickConfirmSave"
      ></molecule-modal-dialog>

      <molecule-modal-dialog
        modalId="modal-confirm-discard-change"
        :isTextCenter="true"
        :textTitle="`Do you want to leave\nwithout finishing?`"
        buttonTextLeft="Confirm"
        buttonTextRight="Cancel"
        @clickButtonLeft="clickConfirmDiscard"
      >
      </molecule-modal-dialog>

      <!-- Modal in Case of action from triple dot  -->
      <molecule-modal-dialog
        modalId="modal-apply-policy-to-multiple-equipment"
        :isTextCenter="true"
        :textTitle="`Apply Policy “${currentPolicyDataForActionFromTripleDot.policyName}”?`"
        textSubtitle="This will apply policy to selected equipment."
        buttonTextLeft="Apply"
        :isSlotBody="true"
        @clickButtonLeft="clickConfirmApplyPolicyForActionFromTripleDot"
      >
        <template #body>
          <div class="modal-apply-policy-from-triple-dot-equipment__list">
            <ul class="list__ul">
              <li
                v-for="(equipment, index) in checkedEquipmentList"
                :key="index"
                class="list__li"
              >
                <label class="list__label">{{ equipment.name }}</label>
              </li>
            </ul>
          </div>
        </template>
      </molecule-modal-dialog>

      <!-- In case that user want to create new policy from action from triple dot -->
      <molecule-modal-dialog
        modalId="modal-create-and-apply-policy-to-multiple-equipment"
        :isTextCenter="true"
        :textTitle="`Do you want to\ncreate “${newPolicy.name}”?`"
        textSubtitle="This will create and apply policy to selected equipment."
        buttonTextLeft="Confirm"
        :isSlotBody="true"
        @clickButtonLeft="clickConfirmCreate"
      >
        <template #body>
          <div
            class="modal-create-and-apply-policy-from-triple-dot-equipment__list"
          >
            <ul class="list__ul">
              <li
                v-for="(equipment, index) in checkedEquipmentList"
                :key="index"
                class="list__li"
              >
                <label class="list__label">{{ equipment.name }}</label>
              </li>
            </ul>
          </div>
        </template>
      </molecule-modal-dialog>

      <molecule-modal-dialog
        modalId="modal-confirm-multiple-monitor-event"
        :isTextCenter="true"
        textTitle="Do you want to Disable Monitoring?"
        textSubtitle="This will disable monitoring to selected equipment."
        buttonTextLeft="Confirm"
        :isSlotBody="true"
        @clickButtonLeft="clickConfirmIsEnabledForActionFromTripleDot"
      >
        <template #body>
          <div class="modal-disable-from-triple-dot-equipment__list">
            <ul class="list__ul">
              <li
                v-for="(equipment, index) in checkedEquipmentList"
                :key="index"
                class="list__li"
              >
                <label class="list__label">{{ equipment.name }}</label>
              </li>
            </ul>
          </div>
        </template>
      </molecule-modal-dialog>
    </div>
  </main>
</template>

<script>
import Vue from "vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomSwitch from "@/components/atoms/AtomSwitch.vue"
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import MoleculeListResource from "@/components/molecules/serverManagementModule/server/MoleculeListResource.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import {
  getPolicyManagementUnits,
  getPolicyManagementById,
  disablePolicyMonitoringToSingleEquipment,
  disablePolicyMonitoringToMultipleEquipment,
  updatePolicyToSingleEquipment,
  updatePolicyToMultipleEquipment,
  addPolicyManagement,
} from "@/api/api-module"
import mixins from "@/mixins"
export default {
  name: "OrganismServerPolicy",
  components: {
    MoleculeListResource,
    MoleculeModalDialog,
    AtomInput,
    AtomButton,
    AtomSwitch,
    AtomSelect,
  },
  mixins: [mixins],
  props: {
    equipmentData: {
      type: Object,
      required: false,
      default: () => {},
    },
    resourceData: {
      type: Array,
      required: false,
      default: () => [],
    },
    policyListFromApi: {
      type: Array,
      required: false,
      default: null,
    },
    isFromTripleDot: {
      type: Boolean,
      required: false,
      default: false,
    },
    checkedEquipmentList: {
      type: Array,
      required: false,
      default: () => [],
    },
    value: {
      type: Object,
      required: true,
    },
    hasUpdatePermission: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["clickBack", "clickCreate", "clickSave", "getEquipmentDetail"],
  data() {
    return {
      isClickApply: false,
      isClickEnable: false,

      // Variable for each equipment policy
      currentSwitchValue: null, // declare this to use with atom switch to prevent bug when modal confirm disable and screen move to the top.
      isErrorCreatePolicyName: false,
      isErrorCreatePolicyDescription: false,
      isEdit: false,
      isError: false,
      errorCreatePolicyName: "",
      errorCreatePolicyDescription: "",
      policyAction: "",
      modalId: "",
      firstStatePolicyNameByEquipment: null,

      //  Variable for action from triple dot
      switchValueForActionFromTripleDot: true,
      currentPolicyDataForActionFromTripleDot: { policyName: "" },

      firstStatePolicyByEquipment: null,
      selectPolicy: { policyName: "Default Policy" },
      policyListAll: [{ policyName: "Create Policy" }],
      columns: [
        {
          key: "resource",
          title: "System Resources",
        },
        {
          key: "warning",
          title: "Warning Theshold",
        },
        {
          key: "critical",
          title: "Critical Theshold",
        },
        {
          key: "unit",
          title: "Units",
        },
      ],
      rows: [
        {
          resource: "CPU",
          warning: "",
          critical: "",
          unit: "",
          isEnabled: false,
        },
        {
          resource: "Memory",
          warning: "",
          critical: "",
          unit: "",
          isEnabled: false,
        },
        {
          resource: "Available Storage",
          warning: "",
          critical: "",
          unit: "",
          isEnabled: false,
        },
      ],
      newPolicy: {
        name: "",
        description: "",
      },
      unitList: {
        cpu: [],
        memory: [],
        storage: [],
      },
      currentRows: [],
    }
  },
  computed: {
    currentEquipmentPolicyData: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },
    messageInButtonApplyNormalVersion() {
      return this.policyAction === "create"
        ? "Create and Apply System Resources"
        : "Apply System Resources"
    },
    messageInButtonApplyShortVersion() {
      return this.policyAction === "create" ? "Create and Apply" : "Apply"
    },
    isDisableApplyButton() {
      if (
        this.currentEquipmentPolicyData.currentPolicy?.policyName ===
        "Create Policy"
      ) {
        if (this.isClickApply) {
          const checkPolicyName = !this.isNotEmptyString(this.newPolicy.name)
          if (checkPolicyName) {
            this.isErrorCreatePolicyName = true
            this.errorCreatePolicyName = "Please enter policy name"
          }
          const checkPolicyDescription = !this.isNotEmptyString(
            this.newPolicy.description
          )
          if (checkPolicyDescription) {
            this.isErrorCreatePolicyDescription = true
            this.errorCreatePolicyDescription = "Please enter description"
          }
          return (
            checkPolicyName ||
            checkPolicyDescription ||
            !this.completeAtLeastOneRow ||
            this.isError
          )
        } else return !this.isEdit
      } else if (
        this.currentEquipmentPolicyData.currentPolicy?.policyName ===
          "Custom Policy" &&
        this.firstStatePolicyNameByEquipment !== "Custom Policy"
      ) {
        if (this.isClickApply) {
          return this.isError || !this.completeAtLeastOneRow
        } else return !this.isEdit
      } else if (
        this.currentEquipmentPolicyData.currentPolicy?.policyName ===
        "Custom Policy"
      ) {
        if (this.isClickApply)
          return (
            JSON.stringify(this.currentRows) ===
            JSON.stringify(this.resourceData)
          )
        else return !this.isEdit
      } else {
        if (this.isClickApply)
          return (
            this.currentEquipmentPolicyData.currentPolicy?.policyName ===
            this.firstStatePolicyByEquipment.policyName
          )
        else return !this.isEdit
      }
    },
    isDisableApplyButtonForActionFromTripleDot() {
      if (
        this.currentPolicyDataForActionFromTripleDot?.policyName ===
        "Create Policy"
      ) {
        if (this.isClickApply) {
          const checkPolicyName = !this.isNotEmptyString(this.newPolicy.name)
          if (checkPolicyName) {
            this.isErrorCreatePolicyName = true
            this.errorCreatePolicyName = "Please enter name policy"
          }
          const checkPolicyDescription = !this.isNotEmptyString(
            this.newPolicy.description
          )
          if (checkPolicyDescription) {
            this.isErrorCreatePolicyDescription = true
            this.errorCreatePolicyDescription = "Please enter description"
          }
          return (
            checkPolicyName ||
            checkPolicyDescription ||
            !this.completeAtLeastOneRow ||
            this.isError
          )
        } else return !this.isEdit
      } else return !this.isEdit
    },
    completeAtLeastOneRow() {
      let checkChange = false
      this.currentRows.forEach((row) => {
        checkChange ||=
          row.isEnabled &&
          this.isNotEmptyString(row.warning) &&
          this.isNotEmptyString(row.critical) &&
          this.isNotEmptyString(row.unit.id)
      })
      return checkChange
    },
  },
  watch: {
    currentEquipmentPolicyData: {
      deep: true,
      handler() {
        this.checkPolicyAction()
        this.setBeforeValidate()
        this.selectedPolicy = this.currentEquipmentPolicyData.currentPolicy
        if (
          (this.currentEquipmentPolicyData.currentPolicy?.policyName ===
            "Create Policy" ||
            this.currentEquipmentPolicyData.currentPolicy?.policyName ===
              "Custom Policy") &&
          this.firstStatePolicyNameByEquipment !==
            this.currentEquipmentPolicyData.currentPolicy?.policyName
        ) {
          this.currentRows.forEach((row) => (row.unit = { id: "", name: "" }))
          this.newPolicy = { name: "", description: "" }
        }

        this.isEdit =
          !(
            this.firstStatePolicyNameByEquipment ===
            this.currentEquipmentPolicyData.currentPolicy?.policyName
          ) || this.isClickEnable
      },
    },
    currentPolicyDataForActionFromTripleDot: {
      deep: true,
      handler() {
        this.checkPolicyAction()
        this.setBeforeValidate()
      },
    },
    currentRows: {
      deep: true,
      handler() {
        if (this.policyAction !== "create") {
          this.checkEditData()
        }
      },
    },
    newPolicy: {
      deep: true,
      handler() {
        if (this.newPolicy.name) {
          this.isErrorCreatePolicyName = false
          this.errorCreatePolicyName = ""
        }
        if (this.newPolicy.description) {
          this.isErrorCreatePolicyDescription = false
          this.errorCreatePolicyDescription = ""
        }
      },
    },
    policyListFromApi: {
      deep: true,
      handler() {
        this.setDefaultPolicyList()
        this.pushPolicyListAll()
        this.saveFirstStateData()
        this.firstStatePolicyNameByEquipment = JSON.parse(
          JSON.stringify(this.equipmentData.currentPolicy.policyName)
        )
        this.firstStatePolicyByEquipment = JSON.parse(
          JSON.stringify(this.equipmentData.currentPolicy)
        )
      },
    },
  },
  async mounted() {
    this.showLoading(true)
    await this.getPolicyManagementUnitsListApi()
    await this.pushPolicyListAll()
    this.saveFirstStateData()
    if (this.isFromTripleDot) {
      await this.setDefaultPolicy()
    }
    this.checkPolicyAction()
  },
  methods: {
    // Set Before Validate
    setBeforeValidate() {
      this.isClickApply = false
      this.isError = false
      this.isErrorCreatePolicyName = false
      this.isErrorCreatePolicyDescription = false
    },
    // Set Default Policy to be initial option (only action from triple dot)
    async setDefaultPolicy() {
      this.currentPolicyDataForActionFromTripleDot = this.policyListAll.filter(
        (policy) => policy.policyName === "Default Policy"
      )[0]
      await this.getPolicyThresholdByPolicyIdApi(
        this.currentPolicyDataForActionFromTripleDot.policyId
      )
    },

    // Save first state of data to use for disable/enable button
    saveFirstStateData() {
      this.rows = JSON.parse(JSON.stringify(this.resourceData))
      this.currentRows = JSON.parse(JSON.stringify(this.rows))
      this.currentSwitchValue = this.equipmentData.isEnable
      this.newPolicy = { name: "", description: "" }
      if (this.equipmentData.currentPolicy) {
        this.firstStatePolicyNameByEquipment = JSON.parse(
          JSON.stringify(this.equipmentData.currentPolicy.policyName)
        )
        this.firstStatePolicyByEquipment = JSON.parse(
          JSON.stringify(this.equipmentData.currentPolicy)
        )
      }
    },

    // Get policy unit by call api.
    getPolicyManagementUnitsListApi() {
      getPolicyManagementUnits().then((response) => {
        response.forEach((unit) => {
          if (unit.policyResourceTypeName === "CPU") {
            this.unitList.cpu.push({
              id: unit.policyUnitId,
              name: unit.policyUnitName,
            })
          } else if (unit.policyResourceTypeName === "Memory") {
            this.unitList.memory.push({
              id: unit.policyUnitId,
              name: unit.policyUnitName,
            })
          } else if (unit.policyResourceTypeName === "Storage") {
            this.unitList.storage.push({
              id: unit.policyUnitId,
              name: unit.policyUnitName,
            })
          }
        })
        this.showLoading(false)
      })
    },

    // Define policy by what current action is (create -> create, edit -> custom, view -> policy from backend )
    checkPolicyAction() {
      if (!this.isFromTripleDot) {
        if (
          this.currentEquipmentPolicyData.currentPolicy?.policyName ===
          "Create Policy"
        ) {
          this.policyAction = "create"
        } else if (
          this.currentEquipmentPolicyData.currentPolicy?.policyName ===
          "Custom Policy"
        ) {
          this.policyAction = "edit"
        } else {
          this.policyAction = "view"
        }
      } else {
        if (
          this.currentPolicyDataForActionFromTripleDot?.policyName ===
          "Create Policy"
        ) {
          this.policyAction = "create"
        } else {
          this.policyAction = "view"
        }
      }
    },

    // Check data when edit.
    checkEditData() {
      let check = false
      for (let i = 0; i < this.currentRows.length; i++) {
        check =
          check ||
          JSON.stringify(this.currentRows[i]) !== JSON.stringify(this.rows[i])
      }
      this.isEdit = check || this.isClickEnable
    },

    // Check error in resource
    errorInResource(isErrorInResourceItem) {
      this.isError = isErrorInResourceItem
    },

    // Open modal from click apply or create (single equipment).
    clickApply() {
      if (this.policyAction === "create") {
        this.modalId = "server-management_modal-confirm-create-policy"
      } else {
        this.modalId = "server-management_modal-confirm-save-policy"
      }

      this.isClickApply = true

      this.$nextTick(() => {
        if (!this.isError && this.isClickApply && this.completeAtLeastOneRow) {
          if (
            this.currentEquipmentPolicyData.currentPolicy?.policyName ===
            "Create Policy"
          ) {
            if (
              !this.isErrorCreatePolicyName &&
              !this.isErrorCreatePolicyDescription
            )
              this.$bvModal.show(this.modalId)
          } else this.$bvModal.show(this.modalId)
        }
      })
    },

    // Open modal from click apply or create (multiple equipment).
    clickApplyForActionFromTripleDot() {
      if (this.policyAction === "create") {
        this.modalId = "modal-create-and-apply-policy-to-multiple-equipment"
      } else {
        this.modalId = "modal-apply-policy-to-multiple-equipment"
      }

      this.isClickApply = true

      this.$nextTick(() => {
        if (!this.isError && this.isClickApply && this.completeAtLeastOneRow) {
          if (
            this.currentEquipmentPolicyData.currentPolicy?.policyName ===
            "Create Policy"
          ) {
            if (
              !this.isErrorCreatePolicyName &&
              !this.isErrorCreatePolicyDescription
            )
              this.$bvModal.show(this.modalId)
          } else this.$bvModal.show(this.modalId)
        }
      })
    },

    // Confirm from click apply in policy modal for single equipment.
    clickConfirmApply() {
      if (
        this.currentEquipmentPolicyData.currentPolicy?.policyName ===
        "Custom Policy"
      ) {
        this.formatCustomPolicyDataApiFormAndSendRequest()
      } else {
        this.formatBasicPolicyDataApiFormAndRequest()
      }
      this.firstStatePolicyByEquipment.policyName =
        this.currentEquipmentPolicyData.currentPolicy?.policyName
      this.closeModal()
      this.setBeforeValidate()
      this.$emit("clickBack")
    },

    // Confirm from click apply policy modal for multiple equipment (triple dot)
    clickConfirmApplyPolicyForActionFromTripleDot() {
      this.formatBasicPolicyDataApiFormAndRequestForActionFromTripleDot()
      this.setBeforeValidate()
      this.$emit("clickBack")
    },

    // Not save change
    clickDiscard() {
      this.modalId = "modal-confirm-discard-change"
      this.$bvModal.show(this.modalId)
    },

    // Confirm discard in modal-confirm-discard-change
    clickConfirmDiscard() {
      this.closeModal()
      this.setBeforeValidate()
      this.currentEquipmentPolicyData.currentPolicy =
        this.equipmentData.currentPolicy
      this.currentRows = JSON.parse(JSON.stringify(this.rows))
      this.$emit("clickBack")
    },

    // Open confirm enable modal for single equipment.
    onClickSwitchEnable() {
      if (!this.currentSwitchValue) {
        Vue.nextTick(() => {
          this.currentSwitchValue = !this.currentSwitchValue
        })

        this.modalId = "modal-confirm-enable-monitor-event"
        this.$bvModal.show(this.modalId)
      } else {
        this.currentEquipmentPolicyData.isEnable =
          !this.currentEquipmentPolicyData.isEnable

        this.isEdit = true
        this.isClickEnable = true
      }
    },

    // Open confirm enable modal for multiple equipment (triple dot).
    onClickSwitchEnableForActionFromTripleDot() {
      Vue.nextTick(() => {
        this.switchValueForActionFromTripleDot =
          !this.switchValueForActionFromTripleDot
      })
      this.modalId = "modal-confirm-multiple-monitor-event"
      this.$bvModal.show(this.modalId)
    },

    // Send Api to disable monitoring for single equipment (action from click confirm in modal).
    clickConfirmIsEnabled() {
      if (this.currentEquipmentPolicyData.isEnable) {
        this.disableMonitoringPolicyByIdApi(this.equipmentData.id)
      }
      this.isClickApply = true

      this.currentEquipmentPolicyData.isEnable =
        !this.currentEquipmentPolicyData.isEnable
      this.currentSwitchValue = this.currentEquipmentPolicyData.isEnable
      this.closeModal()
      this.$emit("clickBack")
    },

    // Send Api to disable monitoring for multiple equipment (action from click confirm in modal).
    async clickConfirmIsEnabledForActionFromTripleDot() {
      const targetDisableMonitoringEquipmentIdList =
        this.checkedEquipmentList.map((equipment) => {
          return equipment.id
        })
      await this.disableMultipleMonitoringPolicyByIdApi(
        targetDisableMonitoringEquipmentIdList
      )
      this.switchValueForActionFromTripleDot =
        !this.switchValueForActionFromTripleDot
      this.closeModal()
      await this.$router.go("/server-management/server-management")
    },

    // confirm create modal (handle both single and multiple equipment).
    async clickConfirmCreate() {
      await this.formatCreatePolicyDataFormAndSendRequest()
      this.rows = JSON.parse(JSON.stringify(this.currentRows))
      this.closeModal()

      let resources = []
      this.rows.forEach((resource) => {
        if (resource.warning && resource.critical && resource.unit) {
          resources.push({
            resourceName: resource.resource,
            resourceEnable: resource.isEnabled,
            resourceWarningThreshold: parseFloat(resource.warning),
            resourceCriticalThreshold: parseFloat(resource.critical),
            resourceUnitId: resource.unit.id,
          })
        }
      })

      this.isEdit = false
      this.isClickEnable = false

      this.$emit("clickCreate", {
        policyName: this.newPolicy.name,
        policyDescription: this.newPolicy.description,
        policyResourceValues: resources,
      })
    },

    // confirm save modal.
    clickConfirmSave() {
      this.rows = JSON.parse(JSON.stringify(this.currentRows))
      this.closeModal()
      this.setBeforeValidate()
      let resources = []
      this.rows.forEach((resource) => {
        if (resource.warning && resource.critical && resource.unit) {
          resources.push({
            policyResourceTypeName: resource.resource,
            policyResourceEnable: resource.isEnabled,
            policyResourceWarningThreshold: parseFloat(resource.warning),
            policyResourceCriticalThreshold: parseFloat(resource.critical),
            policyResourceUnitId: resource.unit.id,
            policyResourceUnit: resource.unit.name,
          })
        }
      })

      this.isEdit = false
      this.isClickEnable = false

      this.$emit("clickSave", {
        usingCustomMonitoringThreshold:
          this.currentEquipmentPolicyData.isEnable,
        policyId: this.currentEquipmentPolicyData.currentPolicy.policyId,
        policyValue: resources,
        usingCustomMonitoringThreshold:
          this.currentEquipmentPolicyData.currentPolicy.policyName ===
          "Custom Policy",
      })
    },

    // close modal
    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = ""
    },

    // Push policy from backend to pushPolicyListAll to be an options for atom select.
    pushPolicyListAll() {
      this.setDefaultPolicyList()
      if (this.isFromTripleDot) {
        this.policyListAll = this.policyListAll.concat(this.policyListFromApi)
      } else {
        this.policyListAll = this.policyListAll.concat(
          { policyName: "Custom Policy" },
          this.policyListFromApi
        )
      }
    },

    // Set policyListAll to be initial (have only create policy) before push others from api.
    setDefaultPolicyList() {
      this.policyListAll = [{ policyName: "Create Policy" }]
    },

    // Function for check change from atom select (watch current policy)
    changeSelectedPolicy(selectedPolicy) {
      if (
        (selectedPolicy.policyName === "Custom Policy" &&
          this.firstStatePolicyNameByEquipment !== "Custom Policy") ||
        selectedPolicy.policyName === "Create Policy"
      ) {
        const initialResourcePolicy = [
          {
            resource: "CPU",
            warning: "",
            critical: "",
            unit: { id: "" },
            isEnabled: false,
          },
          {
            resource: "Memory",
            warning: "",
            critical: "",
            unit: "",
            isEnabled: false,
          },
          {
            resource: "Storage",
            warning: "",
            critical: "",
            unit: { id: "", name: "" },
            isEnabled: false,
          },
        ]
        this.currentRows = initialResourcePolicy
      } else if (selectedPolicy.policyName === "Custom Policy") {
        //this.currentRows = this.resourceData
        this.$emit("getEquipmentDetail")
      } else {
        this.getPolicyThresholdByPolicyIdApi(selectedPolicy.policyId)
      }
    },

    // Send Api to get threshold of policy by policy id
    async getPolicyThresholdByPolicyIdApi(policyId) {
      await getPolicyManagementById(policyId).then((response) => {
        this.currentRows = []
        response.policyValue.forEach((resource) => {
          //get unit name using selected policyResourceUnitId
          let unitSelected = []
          if (resource.policyResourceTypeName === "CPU") {
            unitSelected = this.unitList.cpu.filter(
              (unitItem) => unitItem.id === resource.policyResourceUnitId
            )
          } else if (resource.policyResourceTypeName === "Memory") {
            unitSelected = this.unitList.memory.filter(
              (unitItem) => unitItem.id === resource.policyResourceUnitId
            )
          } else if (resource.policyResourceTypeName === "Storage") {
            unitSelected = this.unitList.storage.filter(
              (unitItem) => unitItem.id === resource.policyResourceUnitId
            )
          }

          if (
            resource.policyResourceTypeName === "CPU" ||
            resource.policyResourceTypeName === "Memory" ||
            resource.policyResourceTypeName === "Storage"
          ) {
            this.currentRows.push({
              resource: resource.policyResourceTypeName,
              warning: resource.policyResourceWarningThreshold,
              critical: resource.policyResourceCriticalThreshold,
              unit: {
                id: resource.policyResourceUnitId,
                name: unitSelected[0].name,
              },
              isEnabled: resource.policyResourceEnable,
            })
          }
        })
        this.currentRows.sort((a, b) => {
          return a.resource.toLowerCase() < b.resource.toLowerCase() ? -1 : 1
        })
      })
    },

    // Send api Disable Monitoring for single equipment
    async disableMonitoringPolicyByIdApi(id) {
      const response = await disablePolicyMonitoringToSingleEquipment(id)
      if (response) this.toastSuccess("Disable monitoring successfully")
      else this.toastError("Disable monitoring failed")
    },

    // Send api Disable monitoring for multiple equipment (triple dot)
    async disableMultipleMonitoringPolicyByIdApi(
      targetDisableMonitoringEquipmentIdList
    ) {
      const response = await disablePolicyMonitoringToMultipleEquipment(
        targetDisableMonitoringEquipmentIdList
      )
      if (response) this.toastSuccess("Disable monitoring successfully")
      else this.toastError("Disable monitoring failed")
    },

    // Format data for basic policy (policy from backend) and call update api to apply for single equipment.
    formatBasicPolicyDataApiFormAndRequest() {
      const policyDataApiForm = {
        usingCustomMonitoringThreshold: false,
        policyId: this.currentEquipmentPolicyData.currentPolicy.policyId,
      }
      this.updatePolicyByEquipmentApi(policyDataApiForm)
    },

    // Format data for basic policy (policy from backend) and call update api to apply for multiple equipment.
    formatBasicPolicyDataApiFormAndRequestForActionFromTripleDot() {
      const policyId = this.currentPolicyDataForActionFromTripleDot?.policyId
      const equipmentIdList = this.checkedEquipmentList.map((equipment) => {
        return equipment.id
      })
      this.updatePolicyToMultipleEquipmentApi(equipmentIdList, policyId)
    },

    // Format data for custom policy (only single equipment/ multiple cannot custom) and call update api.
    formatCustomPolicyDataApiFormAndSendRequest() {
      let policyValue = []
      this.currentRows.forEach((row) => {
        if (row.isEnabled) {
          policyValue.push({
            policyResourceEnable: row.isEnabled,
            policyResourceWarningThreshold: row.warning,
            policyResourceCriticalThreshold: row.critical,
            policyResourceTypeName: row.resource,
            policyResourceUnitId: row.unit.id,
            policyResourceUnit: row.unit.name,
          })
        }
      })
      const policyDataApiForm = {
        usingCustomMonitoringThreshold: true,
        policyValue: policyValue,
      }
      this.updatePolicyByEquipmentApi(policyDataApiForm)
    },

    // Send api update policy to single equipment api.
    async updatePolicyByEquipmentApi(policyDataApiForm) {
      const response = await updatePolicyToSingleEquipment(
        this.equipmentData.id,
        policyDataApiForm
      )
      if (response) this.toastSuccess("Policy updated successfully")
      else this.toastError("Policy update failed")
      this.$router.go(
        "/server-management/server-management/" + this.$route.params.id
      )
    },

    // Send api update policy to multiple equipment api.
    async updatePolicyToMultipleEquipmentApi(equipmentIdList, policyId) {
      const response = await updatePolicyToMultipleEquipment(
        equipmentIdList,
        policyId
      )
      if (response) this.toastSuccess("Policy updated successfully")
      else this.toastError("Policy update failed")
      this.$router.go("/server-management/server-management/")
    },

    // Format data and call create new policy api handle both single and multiple action.
    async formatCreatePolicyDataFormAndSendRequest() {
      let policyResourceValues = []
      // Format data to prepare for send api.
      this.currentRows.forEach((row) => {
        if (row.isEnabled) {
          policyResourceValues.push({
            resourceEnable: true,
            resourceWarningThreshold: row.warning,
            resourceCriticalThreshold: row.critical,
            resourceName: row.resource,
            resourceUnitId: row.unit.id,
          })
        }
      })
      const createPolicyData = {
        policyName: this.newPolicy.name,
        policyDescription: this.newPolicy.description,
        policyResourceValues: policyResourceValues,
      }
      let policyId = await this.createNewPolicyApi(createPolicyData)
      if (!this.isFromTripleDot) {
        // Check if action want to update policy to single equipment.
        const policyDataApiForm = {
          usingCustomMonitoringThreshold: false,
          policyId: policyId,
        }
        this.updatePolicyByEquipmentApi(policyDataApiForm)
      } else {
        // In case that action want to update policy to multiple equipment.
        const targetEquipmentIdList = this.checkedEquipmentList.map(
          (equipment) => {
            return equipment.id
          }
        )
        this.updatePolicyToMultipleEquipmentApi(targetEquipmentIdList, policyId)
      }
    },

    // Send api create new policy.
    async createNewPolicyApi(createPolicyData) {
      const response = await addPolicyManagement(createPolicyData)
      return response.data.policyId
    },

    // Check if text is not blank space or not.
    isNotEmptyString(text) {
      if (text === "") return false
      else return true
    },
  },
}
</script>

<style lang="scss" scoped>
label {
  margin-bottom: 0;
}

.organism-policy_container {
  width: 100%;
  background-color: #ffffff;
}

// header
.organism-policy_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 15px 15px 15px;
}
.header__label {
  font-size: 14px;
  font-weight: 700;
  color: #6e6b7b;
}

// line
.organism-policy_line {
  border: 0.5px solid #ebe9f1;
}

// body
.organism-policy_body {
  padding: 15px 15px 15px 15px;
  position: relative;
}

// policy
.policy__label {
  font-size: 12px;
  color: #5e5873;
}
.policy__select {
  width: 100%;
}

// create policy
.policy__create {
  margin-top: 24px;
  margin-bottom: 7px;
}
.create__title {
  color: #5e5873;
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 25px;
}
.create__name {
  width: 100%;
}
.create__description {
  width: 100%;
  margin-top: 15px;
}

// button
.policy__button,
.policy__button-right {
  margin-top: 20px;
  margin-bottom: 30px;
}
.policy__button-right {
  display: flex;
  justify-content: flex-end;
}
.button__discard {
  margin-left: 10px;
}
.apply__normal {
  display: none;
}

// resources
.resources__column {
  display: flex;
}

// modal
.modal-confirm-enable-monitor-event_list,
.modal-confirm-enable-monitor-event__list--full {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.modal-confirm-enable-monitor-event__list {
  width: 216.44px;
}
.modal-confirm-enable-monitor-event__list--full {
  max-width: 100%;
}
.list__ul {
  margin-bottom: 15px;
  padding-left: 16px;
  max-height: 122px;
  overflow-y: auto;
}
.list__ul--full {
  margin-bottom: 15px;
  padding-left: 16px;
  height: 250px;
  overflow-y: auto;
  margin-top: 15px;
}
.list__title {
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 400;
  color: #6e6b7b;
}
.list__title--medium {
  font-weight: 500;
}
.list__li {
  color: #babfc7;
}
.list__label {
  color: #6e6b7b;
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 6px;
}
.list__label--title {
  color: #5e5873;
  font-weight: 700;
  font-size: 12px;
}
.list__label--topic {
  color: #6e6b7b;
  font-weight: 400;
  font-size: 12px;
  margin-bottom: 5px;
}

// modal for action from triple dot
.modal-disable-from-triple-dot-equipment__list,
.modal-apply-policy-from-triple-dot-equipment__list,
.modal-create-and-apply-policy-from-triple-dot-equipment__list {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  width: 216.44px;
}

.error__text {
  color: #ea5455;
  font-size: 12px;
  bottom: 5px;
}

.padding-left-5px {
  padding-left: 5px;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
  .organism-policy_container-white {
    padding-bottom: 80px;
  }
  // header
  .organism-policy_header {
    padding: 15px 38px 15px 38px;
  }
  .organism-policy_body {
    padding: 15px 38px 15px 38px;
  }
  .policy__select {
    width: 290px;
  }
  .apply__short {
    display: none;
  }
  .apply__normal {
    display: block;
  }
  // create policy
  .create__container {
    display: flex;
  }
  .create__name {
    width: 324px;
  }
  .create__description {
    margin-top: 0;
    margin-left: 10px;
    width: 428px;
  }

  .modal-confirm-enable-monitor-event__list {
    max-width: 216.44px;
  }
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
